<template>
  <div class="edit-report-modal">
    <div
      class="report-backdrop"
      @click.self="$emit('closer', { load: false })"
    >
      <div class="modal">
        <form @submit.prevent="handleSubmit">
          <Spinner class="card" v-if="loading"/>
          <div class="learner-info">
            <label>{{ record.displayName }}</label>
            <label>{{ record.grade }}</label>
          </div>

          <div class="work-items">
            <table class="item-list">
              <tr class="table-heading flex">
                <th class="subject-name">Subject</th>
                <th class="mark">Marks(%)</th>
                <th class="comment">Comment</th>
              </tr>
              <tr class="table-items flex" v-for="(subject, index) in subjectList" :key="index">
                <td class="subject-name"><input type="text" v-model="subject.subjectName" /></td>
                <td class="mark"><input type="number" min="0" max="100" v-model="subject.mark" /></td>
                <td class="comment"><input type="text" v-model="subject.comment" /></td>
                <img @click="deleteSubjectItem(subject.id)" src="@/assets/icon-delete.svg" alt="" />
              </tr>
            </table>

            <div @click="addNewSubjectEntry" class="flex btn">
              <img src="@/assets/icon-plus.svg" alt="" />
              Add New Subject
            </div>
          </div>

          <button>SAVE</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, ref } from 'vue' // , toRefs
import { uid } from 'uid'
import Spinner from './Spinner.vue'
import { db, updateDoc, doc } from '@/firebase/config'

export default {
  name: 'EditClassModal',
  props: ['record'],
  components: { Spinner },
  setup (props, context) {
    const currentUser = inject('currentUser')
    const subjectList = ref([])
    const loading = ref(false)

    const deleteSubjectItem = (id) => {
      subjectList.value = subjectList.value.filter((subject) => subject.id !== id)
    }

    const addNewSubjectEntry = () => {
      subjectList.value.push({
        id: uid(),
        subjectName: '',
        mark: 0,
        comment: ''
      })
    }

    const handleSubmit = async () => {
      loading.value = true
      const post = {
        displayName: props.record.displayName,
        grade: props.record.grade,
        createdAt: props.record.createdAt,
        attendance: props.record.attendance ? props.record.attendance : [],
        subjectList: subjectList.value
      }
      const learnerRecordRef = doc(db,
        '/schools/inspire-schools/' + currentUser.state.grade + '/reports/teacher',
        props.record.id)

      await updateDoc(learnerRecordRef, post)
      context.emit('closer', {
        load: true
      })
    }

    onMounted(() => {
      if (props.record.subjectList) {
        subjectList.value = [...props.record.subjectList]
      }
    })

    return { handleSubmit, subjectList, deleteSubjectItem, addNewSubjectEntry, loading }
  }
}
</script>

<style>
    .edit-report-modal .report-backdrop {
        top: 0;
        left: 0;
        position: fixed;
        background-color: fuchsia;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
        /* z-index: 99; */
    }
    .edit-report-modal .modal {
        border-radius: 10px;
        max-width: 700px;
        width: 80vw;
        background: #fff;
        padding: .1em;
    }
    .edit-report-modal label {
      display: block;
      font-weight: 700;
      color: #010222;
    }
    .edit-report-modal .modal form {
      width: 95% !important;
      display: flex;
      flex-direction: column;
      max-width: 700px;
      margin: 0 auto;
      padding: 0;
    }
    .edit-report-modal .modal .learner-info {
      display: flex;
      justify-content: space-around;
    }
    .edit-report-modal .modal div {
      border: none;
    }
    .edit-report-modal .modal .work-items .item-list {
      width: 100%;
    }
    .table-heading,.table-items {
      gap: 16px;
      font-size: 12px;
    }
    .subject-name {
      flex-basis: 70%;
    }
    .mark {
      flex-basis: 30%;
    }
    .table-heading {
      margin-bottom: 16px;
    }
    th {
      text-align: left;
    }
    .table-items {
      position: relative;
      margin-bottom: 24px;
    }
    .edit-report-modal .modal .work-items img {
      position: absolute;
      top: 15px;
      right: 0;
      width: 12px;
      height: 16px;
      cursor: pointer;
    }
    .edit-report-modal .btn {
      color: #252945;
      align-items: center;
      justify-content: center;
      background: #eee;
      width: 100%;
      border-radius: 30px;
      position: relative;
    }
    .edit-report-modal .modal .work-items .btn img {
      margin-right: 10px;
      top: 8px;
    }
</style>
